var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panorama"},[_c('sep',{attrs:{"name":"L"}}),(_vm.insurers && _vm.annotationOptions && _vm.apenafsByCode && _vm.subjects)?_c('panorama-inner',{attrs:{"annotationOptions":_vm.annotationOptions,"insurers":_vm.insurers,"apenafsByCode":_vm.apenafsByCode,"subjects":_vm.subjects}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }